import { useState, useEffect, useRef } from 'react';

function LoginPage() {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = () => {
    setIsLoading(true);
    window.open('https://app.asana.com/-/login', '_blank');
  };

  const handleGoogleLogin = () => {
    setIsLoading(true);
    window.open('https://app.asana.com/-/login', '_blank');
  };

  // Pontos das construtoras no Brasil (coordenadas ajustadas para o território brasileiro)
  const constructionPoints = [
    { id: 1, x: 55, y: 50, city: 'São Paulo' },
    { id: 2, x: 61, y: 47, city: 'Rio de Janeiro' },
    { id: 3, x: 53, y: 45, city: 'Belo Horizonte' },
    { id: 4, x: 51, y: 40, city: 'Brasília' },
    { id: 5, x: 48, y: 37, city: 'Goiânia' },
    { id: 6, x: 55, y: 55, city: 'Curitiba' },
    { id: 7, x: 57, y: 60, city: 'Porto Alegre' },
    { id: 8, x: 45, y: 33, city: 'Cuiabá' },
    { id: 9, x: 54, y: 51, city: 'Campinas' },
    { id: 10, x: 56, y: 53, city: 'Santos' },
    { id: 11, x: 63, y: 43, city: 'Vitória' },
    { id: 12, x: 46, y: 40, city: 'Campo Grande' },
    { id: 13, x: 52, y: 43, city: 'Uberlândia' },
    { id: 14, x: 58, y: 57, city: 'Florianópolis' },
    { id: 15, x: 49, y: 35, city: 'Anápolis' },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Seção de Login - Compacta */}
      <div className="flex items-center justify-center py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-6">
          {/* Logo em destaque */}
          <div className="text-center">
            <div className="mb-6">
              <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                Credit Pro
              </h1>
            </div>
            <h2 className="text-2xl font-normal text-gray-900 mb-2">
              Bem-vindo ao Credit Pro by Asana
            </h2>
            <p className="text-lg text-gray-600 font-medium mb-4">
              Preparamos a sua incorporadora para o mercado de investidores e capitais
            </p>
            
            {/* VGV Information */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
              <p className="text-lg font-semibold text-blue-900">
                R$ 115 bilhões em VGV
              </p>
              <p className="text-sm text-blue-700">
                sendo analisado pelo mercado de capitais e investidores pessoa física
              </p>
            </div>
          </div>

          <div className="bg-white py-6 px-6 shadow-sm rounded-lg border border-gray-200">
            <div className="space-y-4">
              {/* Botão Google */}
              <button
                onClick={handleGoogleLogin}
                disabled={isLoading}
                className="w-full flex justify-center items-center px-4 py-3 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                <i className="ri-google-fill text-lg mr-3 text-red-500"></i>
                {isLoading ? 'Carregando...' : 'Continuar com Google'}
              </button>

              {/* Separador */}
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500">ou</span>
                </div>
              </div>

              {/* Botão de Login */}
              <button
                onClick={handleLogin}
                disabled={isLoading}
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Carregando...
                  </div>
                ) : (
                  'Fazer Login'
                )}
              </button>

              <div className="text-center">
                <p className="text-sm text-gray-600">
                  Não tem uma conta?{' '}
                  <a 
                    href="https://app.asana.com/-/login" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-medium text-blue-600 hover:text-blue-500 cursor-pointer"
                  >
                    Criar conta
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Globo Terrestre Realista - GRANDE */}
      <div className="py-8 px-4 min-h-[80vh] flex flex-col justify-center">
        <div className="max-w-7xl mx-auto text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
            Construtoras Atendidas em Todo o Brasil
          </h3>
          <p className="text-lg sm:text-xl text-gray-600 mb-6 sm:mb-8">
            Conectando incorporadoras ao mercado de capitais em todo território nacional
          </p>
          
          <div className="flex justify-center mb-6 sm:mb-8">
            <div 
              className="relative w-[280px] h-[280px] sm:w-[400px] sm:h-[400px] lg:w-[600px] lg:h-[600px] mx-auto rounded-full overflow-hidden"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/5a5f21e6fda62c1cb2d82ff25fc2d5e5.jpg')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3), inset 0 0 40px rgba(0,0,0,0.1)',
                border: '2px solid rgba(255,255,255,0.1)',
              }}
            >
              {/* Overlay para destacar o Brasil */}
              <div 
                className="absolute inset-0"
                style={{
                  background: 'radial-gradient(circle at 55% 45%, transparent 25%, rgba(0,0,0,0.3) 70%)',
                }}
              />

              {/* Pontos das Construtoras */}
              {constructionPoints.map((point, index) => (
                <div
                  key={point.id}
                  className="absolute w-3 h-3 sm:w-4 sm:h-4 lg:w-6 lg:h-6 rounded-full animate-pulse cursor-pointer group"
                  style={{
                    top: `${point.y}%`,
                    left: `${point.x}%`,
                    background: 'radial-gradient(circle, #fbbf24 0%, #f59e0b 70%, #d97706 100%)',
                    boxShadow: '0 0 10px #fbbf24, 0 0 20px rgba(251, 191, 36, 0.6)',
                    animationDelay: `${index * 0.3}s`,
                    transform: 'translate(-50%, -50%)',
                    border: '2px solid rgba(255,255,255,0.8)',
                  }}
                >
                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 sm:mb-4 px-2 sm:px-4 py-1 sm:py-2 bg-gray-900 text-white text-xs sm:text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                    {point.city}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 sm:border-l-4 sm:border-r-4 sm:border-t-4 border-transparent border-t-gray-900"></div>
                  </div>
                  
                  {/* Pulso de expansão */}
                  <div 
                    className="absolute inset-0 rounded-full border-2 sm:border-3 border-yellow-300 animate-ping opacity-75"
                    style={{ animationDelay: `${index * 0.4}s`, animationDuration: '2s' }}
                  />
                </div>
              ))}

              {/* Reflexo atmosférico */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, transparent 40%, transparent 60%, rgba(0,0,0,0.1) 100%)',
                }}
              />
            </div>
          </div>

          {/* Estatísticas */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-12 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-600 mb-2 sm:mb-3">40+</div>
              <div className="text-base sm:text-lg lg:text-xl text-gray-600">Cidades Atendidas</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-green-600 mb-2 sm:mb-3">R$ 115bi</div>
              <div className="text-base sm:text-lg lg:text-xl text-gray-600">VGV em Análise</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-yellow-600 mb-2 sm:mb-3">100%</div>
              <div className="text-base sm:text-lg lg:text-xl text-gray-600">Território Nacional</div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer com Selo SiteLock */}
      <footer className="bg-white border-t border-gray-100 py-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col items-center justify-center space-y-4">
            {/* Selo SiteLock */}
            <div className="flex justify-center">
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  window.open('https://www.sitelock.com/verify.php?site=swisscapitalinvest.com.br','SiteLock','width=600,height=600,left=160,top=170');
                }}
                className="cursor-pointer"
              >
                <img 
                  className="h-16 w-auto" 
                  alt="SiteLock" 
                  title="SiteLock - Site Seguro" 
                  src="https://shield.sitelock.com/shield/swisscapitalinvest.com.br" 
                />
              </a>
            </div>

            {/* Copyright */}
            <p className="text-center text-sm text-gray-500">
              © 2024 Credit Pro. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LoginPage;
